import LocalizedStrings from 'localized-strings';

import {
  ShineAccountingExportFormat,
  ShineRecurringAccountingExportSettingsCadence,
  ShineRecurringAccountingExportSettingsType,
} from '__generated__/GQL';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    [ShineRecurringAccountingExportSettingsType.ShineRecurring]: {
      description:
        'Votre **export comptable** sera envoyé le {date} de chaque {period} aux adresses suivantes :',
      title: 'Votre export est planifié !',
    },
    bankStatements: 'Relevés bancaires',
    cadence: {
      [ShineRecurringAccountingExportSettingsCadence.Monthly]: 'mois',
    },
    confirm: 'C’est tout bon !',
    contains: 'Il contiendra les éléments suivants :',
    [ShineAccountingExportFormat.Ofx]: 'OFX',
    [ShineAccountingExportFormat.Csv]: 'CSV',
    [ShineAccountingExportFormat.Qif]: 'QIF',
    exportFormat: 'Export au format {format}',
    invoices: 'Factures',
    personalTransactions: 'Transactions marquées comme personnelles',
  },
  fr: {
    [ShineRecurringAccountingExportSettingsType.ShineRecurring]: {
      description:
        'Votre **export comptable** sera envoyé le {date} de chaque {period} aux adresses suivantes :',
      title: 'Votre export est planifié !',
    },
    bankStatements: 'Relevés bancaires',
    cadence: {
      [ShineRecurringAccountingExportSettingsCadence.Monthly]: 'mois',
    },
    confirm: 'C’est tout bon !',
    contains: 'Il contiendra les éléments suivants :',
    [ShineAccountingExportFormat.Ofx]: 'OFX',
    [ShineAccountingExportFormat.Csv]: 'CSV',
    [ShineAccountingExportFormat.Qif]: 'QIF',
    exportFormat: 'Export au format {format}',
    invoices: 'Factures',
    personalTransactions: 'Transactions marquées comme personnelles',
  },
} as const);

export default locales;
